import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { ContextualClassTitle } from "../../../constants";
import { ContextualClassSubTitle, ContextualListData } from "../../../data/uiKits/Lists";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const ContextualClass = () => {
  return (
    <Col xxl="6" sm="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={ContextualClassTitle} span={ContextualClassSubTitle} />
        <CardBody>
          <ListGroup>
            {ContextualListData &&
              ContextualListData.map((item, index) => (
                <ListGroupItem action className={item.class} key={index}>
                  {item.htmlText}
                </ListGroupItem>
              ))}
          </ListGroup>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ContextualClass;
